<!-- Batch Open in Amended Confirmation Modal Component -->
<!-- Using shared confirmation modal component following fir163jsync pattern -->

<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="showModal"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>
